// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import { css } from "styled-components";
import constants from "@store/constants";
import Zone from "@insite/client-framework/Components/Zone";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";

const contentZoneName = "Content";

const enum fields {
    anchorId = "anchorId",
    title = "title",
}

export interface ProductDetailsGenericProductDocumentsViewProps extends WidgetProps {
    fields: {
        [fields.anchorId]: string;
        [fields.title]: string;
    };
}

export interface ProductDetailsGenericProductDocumentsViewStyles {
    block?: BlockProps;
    title?: TypographyPresentationProps;
}

export const productDetailsGenericProductDocumentsViewStyles: ProductDetailsGenericProductDocumentsViewStyles = {
    block: {
        variant: "alternative",
        margin: "narrow",
        containerCss: css`
            &:not(&:has([data-zone])):has(.no-documents) {
                display: none;
            }
        `,
    },
    title: {
        forwardAs: "h2",
        css: css`
            ${typographyTitleStyles(pxToRemArray([24]))}
            ${spacingStyles(null, "1em")}
        `,
    },
};

const styles = productDetailsGenericProductDocumentsViewStyles;

const ProductDetailsGenericProductDocumentsView: FC<ProductDetailsGenericProductDocumentsViewProps> = ({
    fields: { anchorId, title },
    id,
}) => {
    const contentZoneIsActive = useZoneIsActive(id, contentZoneName);

    if (!contentZoneIsActive) {
        return null;
    }

    return (
        <Block {...styles.block} id={anchorId || undefined}>
            {title && <Typography {...styles.title}>{title}</Typography>}
            {contentZoneIsActive && <Zone contentId={id} zoneName={contentZoneName} />}
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsGenericProductDocumentsView,
    definition: {
        displayName: "Generic Product Documents View",
        group: constants.widgetGroup.productDetails,
        allowedContexts: [constants.pageType.productDetails],
        fieldDefinitions: [
            {
                name: fields.anchorId,
                displayName: "Anchor ID",
                editorTemplate: "TextField",
                defaultValue: "documentation",
                fieldType: "Contextual",
            },
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Documentation",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
